// extracted by mini-css-extract-plugin
export default {"productGrid":"c0-z","centerLink":"d0-z","productSection":"e0-z","item":"f0-z","ctaButton":"g0-z"};